// Клиент для `/api/public/fields` — каталог месторождений публичного юзера
// (OSDU master-data Field, верхушка онтологии Field→Well→Wellbore).
// Тонкая обёртка над generic `crudClient` (см. crudClient.ts).
// Типы — единый источник правды: ts-rs-генерация из
// `crates/backend/web_api_types/src/field.rs` (alias @webtypes, см.
// vite.config.ts / tsconfig.app.json). Регенерация — `cargo test -p web_api_types`.

import type { FieldDto } from '@webtypes/FieldDto'
import type { CreateFieldBody } from '@webtypes/CreateFieldBody'
import type { UpdateFieldBody } from '@webtypes/UpdateFieldBody'
import { crudClient } from './crudClient'

export type { FieldDto, CreateFieldBody, UpdateFieldBody }
// 409 = месторождение используется (когда well начнёт ссылаться на field, FK
// ON DELETE RESTRICT); страница ловит его `instanceof InUseError`.
export { InUseError } from './crudClient'

const client = crudClient<FieldDto, CreateFieldBody, UpdateFieldBody>(
  '/api/public/fields',
  'Месторождение используется в скважинах — удалить нельзя',
)

export const listFields = client.list
export const createField = client.create
export const updateField = client.update
export const deleteField = client.remove
